import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLocalization, LocalizationKeys } from '../../../i18n'
import { buildAuthUrl } from '../../../utils/authRedirect'
import styles from './signInBtn.module.css'

export function SignInBtn() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useLocalization()

  const handleClick = useCallback(() => {
    // Строим URL с сохранением текущего пути для возврата
    const currentPath = location.pathname + location.search + location.hash
    const loginUrl = buildAuthUrl('/signin', currentPath)
    navigate(loginUrl)
  }, [navigate, location])

  return (
    <button
      type="button"
      className={styles.signInBtn}
      onClick={handleClick}
      aria-label={t(LocalizationKeys.AUTH_SIGN_IN)}
    >
      {t(LocalizationKeys.AUTH_SIGN_IN)}
    </button>
  )
}
